import { ResourceContextProvider, SimpleForm, Title, useNotify, useRedirect } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "../SaveForm/SaveForm";
import { Box } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router";
import dataProvider from "server/dataProvider";
import { SPECIALISTS, SpecialistsEnrollmentType, SpecialistServicePath } from "utils/constants";
import { specialistRequests } from "api/specialistApi";
import FindUserByPersonId from "./FindUserByPersonId";
import UserPicker from "./UserPicker";
import ListNonClinicalCandidates from "./ListNonClinicalCandidates";
import { useNotifyError } from "utils/useNotifyError";

const EnrollSpecialist = () => {
  const { type } = useParams();
  const isClinical = type === SpecialistsEnrollmentType.Clinical;

  const notify = useNotify();
  const notifyError = useNotifyError();
  const redirect = useRedirect();

  const [showForm, setShowForm] = useState(false);

  const [personId, setPersonId] = useState("");
  const [clinicalUsersInfo, setClinicalUsersInfo] = useState([]);
  const [selectedUserIndex, setSelectedUserIndex] = useState(0);

  const selectedUser = clinicalUsersInfo[selectedUserIndex] ?? null;

  const [nonClinicalUserInfo, setNonClinicalUserInfo] = useState(null);
  const [specializationInfo, setSpecializationInfo] = useState({});
  const [graduationInfo, setGraduationInfo] = useState(null);

  const defaultValues = isClinical
    ? { userInfo: selectedUser }
    : {
        userInfo: nonClinicalUserInfo,
        graduationInfo,
        ...specializationInfo,
      };

  const pageTitle = isClinical
    ? "Записване на специализант - Клинична специалност"
    : "Записване на специализант - Неклинична специалност";

  const handleSubmit = async data => {
    const { userInfo, ...rest } = data;
    const activeUser = isClinical ? selectedUser : nonClinicalUserInfo;
    const payload = activeUser?.userId ? { ...rest, userId: activeUser.userId } : { ...rest, userInfo };

    try {
      await dataProvider.customRequest(specialistRequests.enrollSpecialists(), payload, "POST");

      notify("Специализантът е записан успешно!", { type: "success" });
      redirect(`/${SpecialistServicePath}${SPECIALISTS}`);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <Box>
      <Title title={pageTitle} />
      <BackButtonToolbar />
      {!showForm && isClinical && (
        <FindUserByPersonId
          personId={personId}
          setPersonId={setPersonId}
          setFoundUsersInfo={setClinicalUsersInfo}
          setSelectedUserIndex={setSelectedUserIndex}
          setShowForm={setShowForm}
        />
      )}
      {!showForm && !isClinical && (
        <ListNonClinicalCandidates
          setShowForm={setShowForm}
          setNonClinicalUserInfo={setNonClinicalUserInfo}
          setSpecializationInfo={setSpecializationInfo}
          setGraduationInfo={setGraduationInfo}
        />
      )}
      {showForm && clinicalUsersInfo.length > 1 && (
        <UserPicker
          users={clinicalUsersInfo}
          selectedIndex={selectedUserIndex}
          onChange={setSelectedUserIndex}
        />
      )}
      {showForm && (
        <ResourceContextProvider value="enroll-specialist">
          <SimpleForm
            key={nonClinicalUserInfo?.userId ?? selectedUserIndex}
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
          >
            <SaveForm
              foundUserInfo={isClinical ? selectedUser : nonClinicalUserInfo}
              specializationInfo={specializationInfo}
              isClinical={isClinical}
              graduationInfo={graduationInfo}
            />
          </SimpleForm>
        </ResourceContextProvider>
      )}
    </Box>
  );
};

export default EnrollSpecialist;
